export default interface DadosBancarioTipo {
    codigo: number|EnumDadoBancarioTipo;
    nome: string;
    ativo: boolean;
    dataCriacao: Date;
}

export enum EnumDadoBancarioTipo {
    Conta = 1,
    ChavePix
}